(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgt-calendar-participate"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tgt-calendar-poll')) {
  customElements.define('tgt-calendar-poll', class extends HTMLElement {
    connectedCallback() {
      const labelFrames = () => this.querySelectorAll('iframe').forEach(frame => {
        if (!frame.title && this.dataset.frameTitle) frame.title = this.dataset.frameTitle;
      });
      labelFrames();
      this.frameObserver = new MutationObserver(labelFrames);
      this.frameObserver.observe(this, { childList: true, subtree: true });
    }
    disconnectedCallback() { this.frameObserver?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgt-giveaway"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tgt-giveaway')) {
  customElements.define('tgt-giveaway', class extends HTMLElement {
    connectedCallback() {
      this.updateStatus = () => {
        const deadline = Date.parse(this.dataset.deadline);
        const expired = (Number.isFinite(deadline) && Date.now() > deadline) || new URLSearchParams(location.search).get('htmtest') === 'ende';
        this.querySelectorAll('[data-active-only]').forEach(element => { element.hidden = expired; });
        this.querySelectorAll('[data-ended-only]').forEach(element => { element.hidden = !expired; });
      };
      this.updateStatus();
      this.timer = setInterval(this.updateStatus, 1000);
      this.handleClick = event => {
        const play = event.target.closest('[data-play]');
        if (play && this.contains(play)) {
          const video = this.querySelector('[data-video-template]');
          play.replaceWith(video.content.cloneNode(true));
          this.querySelector('.tgt-giveaway__video iframe')?.focus();
          return;
        }
        const link = event.target.closest('a');
        if (!link) return;
        const href = link.getAttribute('href');
        if (href !== '#tgt-teilnahme' && href !== '#teilnahmebedingungen') return;
        const target = this.querySelector(href);
        if (!target) return;
        event.preventDefault();
        if (target.tagName === 'DETAILS') target.open = true;
        target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        (target.querySelector('summary') || target).focus({preventScroll:true});
      };
      this.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.removeEventListener('click', this.handleClick);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgt-updates"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tgt-updates')) {
  customElements.define('tgt-updates', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (this.abort) return;
      this.panels = Array.from(this.querySelectorAll('[data-update-panel]'));
      this.tabs = Array.from(this.querySelectorAll('[data-update-tab]'));
      if (this.tabs.length < 2 || this.tabs.length !== this.panels.length) return;
      this.abort = new AbortController();
      const opts = {signal: this.abort.signal};
      this.rotation = this.querySelector('[data-update-rotation]');
      this.stage = this.querySelector('[data-update-stage]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = this.dataset.autoplay === 'true';
      this.delay = Math.max(3, Number(this.dataset.interval) || 5) * 1000;
      this.paused = this.motion.matches;
      this.hovered = matchMedia('(hover: hover)').matches && this.matches(':hover');
      this.focused = this.contains(document.activeElement);
      this.editorSelected = false;
      this.querySelector('[data-update-tabs]').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].tabIndex = 0;
        tab.addEventListener('click', event => {event.preventDefault(); this.activate(index);}, opts);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.activate(next);
          this.tabs[next].focus({preventScroll: true});
        }, opts);
      });
      if (this.rotation && this.enabled) {
        this.rotation.hidden = false;
        this.rotation.addEventListener('click', () => {
          this.paused = !this.paused;
          this.schedule();
        }, opts);
      }
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        this.schedule();
      }, opts);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = false;
        this.schedule();
      }, opts);
      this.addEventListener('focusin', () => {this.focused = true; this.schedule();}, opts);
      this.addEventListener('focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, opts);
      document.addEventListener('visibilitychange', () => this.schedule(), opts);
      this.motion.addEventListener('change', event => {
        if (event.matches) this.paused = true;
        this.schedule();
      }, opts);
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) {this.editorSelected = true; this.activate(index);}
      }, opts);
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.panels.some(panel => panel.dataset.blockId === event.detail.blockId)) return;
        this.editorSelected = false;
        this.schedule();
      }, opts);
      this.activate(0);
    }
    activate(index) {
      this.activeIndex = index;
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      this.timer = null;
      const running = this.enabled && !this.paused && !this.hovered && !this.focused && !this.editorSelected && !document.hidden;
      this.stage?.setAttribute('aria-live', running ? 'off' : 'polite');
      if (this.rotation) {
        this.rotation.setAttribute('aria-label', this.paused ? this.rotation.dataset.playLabel : this.rotation.dataset.pauseLabel);
        this.rotation.querySelector('[data-update-pause-icon]').hidden = this.paused;
        this.rotation.querySelector('[data-update-play-icon]').hidden = !this.paused;
      }
      if (!running || !this.isConnected) return;
      this.timer = setTimeout(() => this.activate((this.activeIndex + 1) % this.panels.length), this.delay);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      clearTimeout(this.timer);
      this.abort?.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
